
<br>
<div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
                <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title text-danger" id="modal-basic-title">{{ModalHeader}} </h4>
</div>
<div class="modal-body" >
   <form name="form" (ngSubmit)="f.form.valid && saveVowd()" #f="ngForm"  novalidate>
                <div class="row">
                                <div class="col-md-4">
                                        <label for="SupplierNamelbl"  class="col-form-label">Supplier AB#</label>
                                </div>
                                <div class="col-md-8">
                                             <div class="form-group">
                                                <input  name="SupplierNamelbl"  (selectItem)="selectedItemSup($event)" id="SupplierNamelbl" type="text" class="form-control" [(ngModel)]="SupName" [ngbTypeahead]="searchSupplier"  placeholder="Supplier No"  #SupplierNo="ngModel" [ngClass]="{ 'is-invalid': f.submitted && SupplierNo.invalid }" required/>
                                                <div *ngIf="f.submitted && SupplierNo.invalid" class="invalid-feedback invalid-display">
                                                        <div *ngIf="SupplierNo.errors?.['required']">Supplier AB No required</div>
                                                </div>
                                             </div>
                                               
                                 </div>
                </div>
                <div class="row">
                                <div class="col-md-4">
                                        <label for="SupplierShortName" class="col-form-label">Supplier Short Name</label>
                                </div>
                                <div class="col-md-8">
                                             <div class="form-group">
                                                        <input type="text" [(ngModel)]="SupShortName" class="form-control" id="SupplierShortName" name="SupplierShortName"
                                                        placeholder="Supplier Short Name" #SupplierShortName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && SupplierShortName.invalid }" required>
                                                        <div *ngIf="f.submitted && SupplierShortName.invalid" class="invalid-feedback invalid-display">
                                                                        <div *ngIf="SupplierShortName.errors?.['required']">Supplier short name is required</div>
                                                        </div>
                                             </div>
                                               
                                 </div>
                </div>
        
                 <div class="row">
                        <div class="col-md-4">
                                <label for="CostCenter" class="col-form-label">Cost Center</label>
                        </div>
                        <div class="col-md-8">
                                     <div class="form-group">
                                                <input  id="CostCenter" placeholder="Cost Center"  (selectItem)="selectedItem($event)" name ="CostCenter" type="text" class="form-control" [(ngModel)]="SelectedCC" [ngbTypeahead]="searchCostCenter" #CostCenter="ngModel" [ngClass]="{ 'is-invalid': f.submitted && CostCenter.invalid }" required/> 
                                                <div *ngIf="f.submitted && CostCenter.invalid" class="invalid-feedback invalid-display">
                                                        <div *ngIf="CostCenter.errors?.['required']">Cost center is required</div>
                                                </div> 
                                     </div>
                         </div>
                </div>
        
               <div class="row">
                                <div class="col-md-4">
                                        <label for="ObjectAccountlbl" class="col-form-label">Object Account</label>
                                </div>
                                <div class="col-md-8">
                                             <div class="form-group">
                                                                <input  name="ObjectAccountlbl" placeholder="Object Account" id="ObjectAccountlbl" type="text" class="form-control" (selectItem)="selectedObjAccount($event)" [(ngModel)]="SelectedAcnt" [ngbTypeahead]="searchObjectAcnt" #ObjectAccount="ngModel" [ngClass]="{ 'is-invalid': f.submitted && ObjectAccount.invalid }" required/>
                                                                <div *ngIf="f.submitted && ObjectAccount.invalid" class="invalid-feedback invalid-display">
                                                                        <div *ngIf="ObjectAccount.errors?.['required']">Object account is required</div>
                                                                </div>
                                             </div>
                                               
                                 </div>
                </div>
                
                <div class="row">
                        <div class="col-md-4">
                                <label class="col-form-label">Contract
                                </label>
                        </div>
                        <div class="col-md-8">
                                <div class="form-group">
                                        <input name="Contractlbl" placeholder="Contract" id="Contractlbl" type="text" #ContractId="ngModel" [ngClass]="{ 'is-invalid': f.submitted && ContractId.invalid }" [(ngModel)]="SelectedContract" [ngbTypeahead]="searchContract"  class="form-control" [required]="CheckUser()" >
                                        <div *ngIf="f.submitted && ContractId.invalid" class="invalid-feedback invalid-display">
                                                <div *ngIf="ContractId.errors?.['required']">Contract ID is required</div>
                                        </div>     
                                </div>
                        </div>                        
                </div>
                
                 <div class="row">
                                <div class="col-md-4">
                                        <label for="MonthYear" class="col-form-label">Month/Year</label>
                                </div>
                                <div class="col-md-8">
                                             <div class="form-group">
                                                <input type="text" [(ngModel)]="MonthYear" class="form-control" id="MonthYear" name="MonthYear"
                                                        placeholder="Month/Year" readonly>
                                             </div>
                                               
                                 </div>
                </div>
        
                <div class="row">
                                <div class="col-md-4">
                                        <label for="DivisionField" class="col-form-label">Division/Field</label>
                                </div>
                                <div class="col-md-8">
                                             <div class="form-group">
                                                        <input type="text"  class="form-control" id="DivisionField" [(ngModel)]="DivisionField"  name="DivisionField"
                                                        placeholder="Division Field" readonly>
                                             </div>
                                               
                                 </div>
                </div>
                <div class="row">
                        <div class="col-md-4">
                                <label for="CompanyCd" class="col-form-label">Company Code</label>
                        </div>
                        <div class="col-md-8">
                                     <div class="form-group">
                                                <input type="text"  class="form-control" id="CompanyCd" [(ngModel)]="CompanyCode"  name="CompanyCd"
                                                placeholder="Company Code" readonly>
                                     </div>
                                       
                         </div>
               </div>
               <div class="row">
                    <div class="col-md-4">
                        <label for="AreaId" class="col-form-label">Area</label>
                    </div>
                  <div class="col-md-8">
                             <div class="form-group">
                                        <input type="text"  class="form-control" id="AreaId" [(ngModel)]="AreaModel"  name="AreaId"
                                        placeholder="Area" readonly>
                             </div>
                               
                   </div>
               </div>
                 <div class="row">
                        <div class="col-md-4">
                                <label for="DepartmentId" class="col-form-label">Department</label>
                        </div>
                        <div class="col-md-8">
                                     <div class="form-group">
                                                <input type="text"  class="form-control" id="DepartmentId" [(ngModel)]="DepartmentModel"  name="DepartmentId"
                                                placeholder="Department" readonly>
                                     </div>
                                       
                         </div>
                </div>
               <div class="row">
                        <div class="col-md-4">
                                <label for="Currency" class="col-form-label">Currency</label>
                        </div>
                        <div class="col-md-8">
                                     <div class="form-group">
                                                <select id="Currency" class="form-control" [(ngModel)]="SelectedCur" name="Currency" #Currency="ngModel" [ngClass]="{ 'is-invalid': f.submitted && Currency.invalid }" required>
                                                        <option value="" selected>Select</option>
                                                        <option *ngFor="let cur of lstCurrency" [ngValue]="cur.CurrencyCode"  >{{cur.CurrencyCode}} </option>
                                                </select>
                                                <div *ngIf="f.submitted && Currency.invalid" class="invalid-feedback invalid-display">
                                                                <div *ngIf="Currency.errors?.['required']">Currency is required</div>
                                                </div>
                                     </div>
                         </div>
                </div>

                <div class="row">
                                <div class="col-md-4">
                                        <label for="ContractVOWDAmount"  class="col-form-label">VOWD Amount</label>
                                </div>
                                <div class="col-md-8">
                                             <div class="form-group">
                                                        <input type="text" [(ngModel)]="ContractVOWDAmount" class="form-control" id="ContractVOWDAmount" name ="ContractVOWDAmount" (change)="checkRemainingValue()"
                                                        placeholder="VOWDAmount" #ContractAmount="ngModel" [ngClass]="{ 'is-invalid': f.submitted && ContractAmount.invalid }" required>
                                                        <div *ngIf="f.submitted && ContractAmount.invalid" class="invalid-feedback invalid-display">
                                                                        <div *ngIf="ContractAmount.errors?.['required']">VOWD amount is required</div>
                                                        </div>
                                             </div>
                                               
                                 </div>
                </div> 
                <div class="row">
                                <div class="col-md-4">
                                        <label for="DescriptionofWork" class="col-form-label">Description of Work</label>
                                </div>
                                <div class="col-md-8">
                                             <div class="form-group">
                                                        <input type="text" class="form-control" id="DescriptionofWork" [(ngModel)]="DescriptionofWork" name="DescriptionofWork"
                                                        placeholder="Description of Work">
                                             </div>
                                               
                                 </div>
                </div> 
                <div class="row" style="text-align: center"  >
                                <button class="btn btn-primary " >Save</button> &nbsp;
                                <button type="button" class="btn btn-primary" (click)="closeModal()">
                                  <span class="glyphicon glyphicon-remove"></span>
                                  Close
                                </button>
                </div>
    </form>
       
</div>

<div class="modal-footer"  style="text-align: center;">
              
</div>
